import { generateAutomationName } from "../../../../../helpers/generateAutomationName";

export const contextMenuKeys = {
    wrapper: generateAutomationName("home", ["projects", "list", "item", "menu", "container"]),
    item: generateAutomationName("home", ["projects", "list", "menu", "item"]),
};
